import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function MadeForSection() {
  const madeFor = ['Training days', 'Deep work', 'Afternoon dip', 'Coffee crash people', 'Long days that need a second gear'];
  const notMadeFor = ['Max-stim chaos', 'Sugary energy drinks', 'Bedtime use', 'The strongest hit possible'];
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-110">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-111">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-headline text-4xl md:text-5xl text-charcoal text-center mb-12" data-id="element-112">
          Made for the energy routine you actually live.
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-113">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-[2rem] p-8 md:p-10 shadow-sm" data-id="element-114">
            <div className="flex items-center mb-8" data-id="element-115">
              <div className="w-8 h-8 rounded-full bg-lime flex items-center justify-center mr-4" data-id="element-116">
                <CheckIcon className="w-5 h-5 text-charcoal" strokeWidth={3} data-id="element-117" />
              </div>
              <h3 className="font-bold text-2xl text-charcoal" data-id="element-118">Made for</h3>
            </div>
            <ul className="space-y-6 text-gray-800 font-medium" data-id="element-119">
              {madeFor.map((item, i) => <li key={i} className="flex items-center" data-id="element-120">
                  <span className="w-1.5 h-1.5 rounded-full bg-lime mr-4 flex-shrink-0" data-id="element-121"></span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-[2rem] p-8 md:p-10 shadow-sm" data-id="element-122">
            <div className="flex items-center mb-8" data-id="element-123">
              <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center mr-4" data-id="element-124">
                <XIcon className="w-5 h-5 text-gray-400" strokeWidth={3} data-id="element-125" />
              </div>
              <h3 className="font-bold text-2xl text-charcoal" data-id="element-126">Not made for</h3>
            </div>
            <ul className="space-y-6 text-gray-500 font-medium" data-id="element-127">
              {notMadeFor.map((item, i) => <li key={i} className="flex items-center" data-id="element-128">
                  <span className="w-1.5 h-1.5 rounded-full bg-gray-300 mr-4 flex-shrink-0" data-id="element-129"></span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}